<template>
  <van-dialog
    theme="round-button"
    class="custom-dialog"
    v-model="show"
    title="提示"
    :before-close="beforeClose"
    @confirm="confirm"
  >
    <div class="dialog-content">
      <span>系统计算行驶公里数为</span>
      <span class="color-orange">{{ getCeilNum(orderMileage) }}</span>
      <span>公里，请确认是否有误差，如果误差请填写实际里程：</span>
    </div>
    <div class="dialog-form">
      <div
        v-if="!isAppeal"
        class="appeal-btn"
        @click="showAppealInput"
      >申诉行驶公里数</div>
      <van-field
        v-else
        class="input-box"
        v-model="appealDistance"
        placeholder="请输入手机里程"
        extra="公里"
      >
        <span slot="extra">
          公里
        </span>
      </van-field>
    </div>
  </van-dialog>
</template>

<script>
import {
  appealDistance
} from '@/common/apiGeneral.js';
export default {
  name: 'AppealDialog',
  props: {
    taskNo: {
      type: String,
      default: ''
    },
    orderMileage: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      show: false,
      isAppeal: false,
      appealDistance: ''
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    beforeClose(action, done) {
      console.log(action, done);
      if (action === 'confirm') {
        if (this.appealDistance) {
          if (!/^(0|([1-9]\d{0,3}))$/g.test(this.appealDistance)) {
            this.$toast('请输入整数，最多4位');
            done(false);
          } else {
            done();
          }
        } else {
          done();
        }
      }
    },
    confirm() {
      if (this.appealDistance) {
        if (/^(0|([1-9]\d{0,3}))$/g.test(this.appealDistance)) {
          this.appealDistanceHandle();
        }
      } else {
        this.close();
      }
    },
    showAppealInput() {
      this.appealDistance = this.orderMileage;
      this.isAppeal = true;
    },
    getCeilNum(val) {
      return Math.round(val);
    },
    // 申述里程
    async appealDistanceHandle(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        await appealDistance({
          taskNo: this.taskNo,
          appealDistance: this.appealDistance
        });
        this.$emit('refresh');
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-dialog{
  &.van-dialog ::v-deep {
    .van-dialog__header{
      padding: 14px 0;

      text-align: center;

      color: #383838;
      border-radius: 8px 8px 0px 0px;
      background: #FFFFFF;
      box-shadow: inset 0px -1px 0px 0px rgba(230,230,230,1);

      font-family: PingFangSC-Regular;
      font-size: 16px;
      font-weight: 400;
    }
    .van-dialog__content{
      .dialog-content{
        padding: 24px 16px;

        text-align: center;
        letter-spacing: -0.41px;

        color: #646464;

        font-family: PingFangSC-Regular;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;

        .color-orange{
          color: #FF8A59;
        }
      }
      .dialog-form{
         padding: 0 16px 24px;
        .appeal-btn{
          text-align: center;
          letter-spacing: -0.41px;

          color: #3399FF;

          font-size: 16px;
          font-weight: 400;
        }

        .input-box{
          padding: 4px 12px;

          letter-spacing: -0.38px;

          color: #383838;
          border: 1px solid #C8C8C8;
          border-radius: 4px;
          background: #FFFFFF;

          font-family: PingFangSC-Regular;
          font-size: 15px;
          font-weight: 400;
          line-height: 21px;
        }
      }
    }
    .van-dialog__footer {
      padding: 0 16px 24px;
      .van-button {
        height: 40px;

        text-align: center;
        letter-spacing: -0.41px;

        & + .van-button {
          margin-left: 17px;
        }
        &.van-dialog__cancel {
          color: #646464;
          border-radius: 8px;
          background: #EDF2F7;

          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: 400;
        }
        &.van-dialog__confirm {
          color: #ffffff;
          border-radius: 8px;
          background: #3399FF;

          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
